import { scrollToSection } from "@/components/site/Nav";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-white text-navy-dark border-t border-silver">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          <div>
            <img src="/logo.png" alt="Karen's Caring Hands, LLC" className="h-24 md:h-28 w-auto" />
            <p className="mt-4 text-sm text-navy-dark/60 max-w-sm leading-relaxed">
              Warm, dependable in-home care for the people you love. Licensed, insured,
              and always personal.
            </p>
            <p className="mt-6 text-sm text-navy-dark/80">248-497-5650 · Care@karenscaringhands.com</p>
            <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.25em] text-navy-dark/50">
              Serving Oakland County & surrounding areas
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-10 gap-y-4">
            {["about", "services", "stories", "careers", "contact"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToSection(id)}
                className="text-xs font-semibold uppercase tracking-[0.2em] text-navy-dark/60 hover:text-navy transition-colors duration-300"
              >
                {id}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div data-testid="footer-bottom-bar" className="bg-navy-dark">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-white/50">
            © 2026 Karen's Caring Hands. All rights reserved.
          </p>
          <a
            data-testid="footer-admin-link"
            href="/admin"
            className="text-[10px] font-mono uppercase tracking-[0.25em] text-white/50 hover:text-white transition-colors duration-300"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
